import React from 'react'

import {
  Box,
  Display,
  DisplayPosition,
  FlexDirection,
  JustifyContent,
} from '@gousto-internal/citrus-react'

import { TabButton } from './TabButton'
import { BoxPricesTabsProps } from './boxPricesTabsModels'

export const BoxPricesTabs = ({ labels, activeIndex, setActiveIndex }: BoxPricesTabsProps) => (
  <Box
    display={[Display.Flex, Display.None]}
    flexDirection={FlexDirection.Column}
    data-testid="boxPricesTabs"
  >
    <Box
      display={[Display.Flex, Display.None]}
      justifyContent={JustifyContent.Center}
      gap={2}
      position={DisplayPosition.Relative}
      paddingH={3}
      top="1px"
    >
      {labels.map((label, index) => (
        <TabButton
          key={label}
          text={label}
          isActive={activeIndex === index}
          onClick={() => setActiveIndex(index)}
        />
      ))}
    </Box>
  </Box>
)
